import TaskComment from 'models/task_comment';

export default class AddCommentToTask {
  constructor(context) {
    this.context = context;
  }

  run({ message, itemId }) {
    let initiatingAgentId = this.context.stores.currentAgent.get().id;

    let comment = TaskComment.create({ itemId, message, initiatingAgentId });
    let commentJs = comment.toJs();

    let taskInfo = this.context.stores.taskInfo.findBy({ id: itemId });
    taskInfo.addComment(comment);
    this.context.stores.taskInfo.setPending(taskInfo);

    this.context.gateways.taskComments.add({ taskId: itemId }, commentJs);

    let currentLocation = this.context.stores.currentLocation.get();
    const customerId = currentLocation.customerId;
    this.context.analytics.track('Task Comment Added', { customerId, itemId });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/task/add_comment_to_task.js